var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Wrapper, Drawer, Icon, Loading } from '@mademine/components';
import { ReactComponent as IconCLose } from '../../assets/icon-arrow-bold-close.svg';
import { I18n } from '@mademine/utils';
import { Fragment, useEffect, useRef, useState } from 'react';
import { useData } from '../../hooks/useData';
import { TaskStatus } from '../../pages';
import { Sketchfab } from '@sunzi/components';
var VisualizePreview = function (_a) {
    var taskStatus = _a.taskStatus, setViualizerPreviewVisible = _a.setViualizerPreviewVisible, onSkipEdit = _a.onSkipEdit, onEnterEdit = _a.onEnterEdit;
    var _sketchfab = useRef(null);
    var _b = useState(false), loadError = _b[0], setLoadError = _b[1];
    var _c = useData(), EditPageNextElement = _c.EditPageNextElement, imageDataFor3dPreview = _c.imageDataFor3dPreview;
    var _d = useState(false), sketchfabLoaded = _d[0], setSketchfabLoaded = _d[1];
    var previewConfig = {
        moduleID: '0ae6e050a91d4c2baed96451a6b218e1',
        moduleName: 'Custom_UV_Layer'
    };
    var onClose = function () {
        setViualizerPreviewVisible(false);
    };
    var onVisualizeConfirm = function () {
        var _a;
        (_a = EditPageNextElement.current) === null || _a === void 0 ? void 0 : _a.click();
    };
    var updateTexture = function (uvname, content) { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!_sketchfab.current) return [3, 4];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4, _sketchfab.current.updateTexture(uvname, content)];
                case 2:
                    _a.sent();
                    return [3, 4];
                case 3:
                    error_1 = _a.sent();
                    console.error('Texture Update Error:', error_1);
                    return [3, 4];
                case 4: return [2];
            }
        });
    }); };
    useEffect(function () {
        if (sketchfabLoaded && imageDataFor3dPreview) {
            updateTexture(previewConfig.moduleName, imageDataFor3dPreview);
        }
    }, [sketchfabLoaded, imageDataFor3dPreview]);
    return (_jsx(Wrapper, { position: "absolute", className: "_sz-z-10 ", children: _jsx(Drawer, { position: "bottom", onClose: onClose, mask: true, children: _jsxs("div", { className: "_sz-rounded-t-2xl _sz-bg-white _sz-p-5 _sz-pb-9 sm:_sz-pb-5", children: [_jsxs("div", { className: "_sz-relative _sz-flex _sz-items-center _sz-justify-center _sz-mb-5", children: [_jsx("div", { className: "_sz-absolute _sz-left-0 _sz-cursor-pointer _sz-h-full _sz-w-10 _sz-flex _sz-items-center _sz-justify-center", onClick: onClose, children: _jsx(Icon, { size: 24, color: "#191919", children: _jsx(IconCLose, {}) }) }), _jsx("span", { className: " _sz-text-center _sz-text-xl _sz-font-extrabold _sz-text-black _sz-m-0", children: I18n.format('modules.mini.me.3d.preview') })] }), _jsxs("div", { className: "_sz-relative _sz-w-full _sz-rounded-lg  _sz-h-full", children: [!sketchfabLoaded && (_jsx("div", { className: "_sz-absolute _sz-inset-0 _sz-z-10 _sz-flex _sz-items-center _sz-justify-center _sz-bg-white", children: _jsx(Loading, { size: 30, color: "black" }) })), _jsx(Sketchfab, { ref: _sketchfab, options: {
                                    load_timeout: 30 * 1000
                                }, className: " _sz-w-full _sz-h-[350px] _sz-rounded-lg", modelId: previewConfig.moduleID, onloaded: function () {
                                    setSketchfabLoaded(true);
                                }, onerror: function (e) {
                                    setLoadError(true);
                                    setSketchfabLoaded(true);
                                    if (e === 'No Hardware Support for Webgl') {
                                        console.error('No Hardware Support for Webgl');
                                    }
                                    else {
                                        console.error('Preview Sketchfab Load Timeout');
                                    }
                                } }), loadError ? (_jsx(Wrapper, { className: "tw-flex tw-flex-col tw-justify-center tw-items-center tw-px-8 tw-bg-gray-2", children: _jsx(Fragment, { children: _jsx("span", { className: "tw-text-14-regular tw-text-gray-5 tw-text-center", children: '3d preview loading failed' }) }) })) : null] }), taskStatus === TaskStatus.Preview ? (_jsx("button", { type: "button", onClick: onVisualizeConfirm, className: " _sz-mt-5 _sz-h-[58px] _sz-w-full _sz-cursor-pointer _sz-rounded-lg _sz-border-none _sz-bg-black _sz-text-base _sz-font-extrabold _sz-text-white", children: I18n.format('modules.mini.me.3d.preview.next') })) : (_jsxs(_Fragment, { children: [_jsx("button", { type: "button", onClick: onSkipEdit, className: " _sz-mt-5 _sz-h-[58px] _sz-w-full _sz-cursor-pointer _sz-rounded-lg _sz-border-none _sz-bg-black _sz-text-base _sz-font-extrabold _sz-text-white", children: I18n.format('pass.edit') }), _jsx("button", { type: "button", onClick: onEnterEdit, className: " _sz-mt-4 _sz-h-[58px] _sz-w-full _sz-cursor-pointer _sz-rounded-lg _sz-border _sz-border-solid _sz-border-black _sz-bg-white _sz-text-base _sz-font-semibold _sz-text-black", children: I18n.format('modules.mini.me.edit.title') })] }))] }) }) }));
};
export default VisualizePreview;
